export const TranslationsFR = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
    },
    // BASE
    phrases: {
        order_online: "Commander",
        cart: "Panier",
        open_24: "24 heures",
        closed: "Fermé",
        free: "GRATUIT",
        something_went_wrong: "Un problème est survenu",
        try_again: "essayez de nouveau",
    },
    constants: {
        calendar: {
            days: {
                monday: "Lundi",
                tuesday: "Mardi",
                wednesday: "Mercredi",
                thursday: "Jeudi",
                friday: "Vendredi",
                saturday: "Samedi",
                sunday: "Dimanche",
            },
        },
        services: {
            pickup: "À emporter",
            delivery: "Livraison",
            dine_in: "Sur place",
            table_booking: "Réservation une table",
        },
        payment: {
            method: {
                cash: "Argent comptant",
                card: "Carte",
                stripe: "Carte de crédit",
                paypal: "PayPal",
                cardconnect: "Carte de crédit",
                paygate_payweb: "PayGate PayWeb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "Bambora APAC",
                pesapal: "Pesapal",
                custom: "Personnalisé",
            },
            backend_method: {
                cash: "Argent comptant",
                card: "Carte",
                stripe: "Card/Wallet",
                paypal: "PayPal",
                cardconnect: "CardConnect",
                paygate_payweb: "PayGate PayWeb",
                poli_pay: "POLi Pay",
                ipay88: "iPay88",
                bambora_apac: "Bambora APAC",
                pesapal: "Pesapal",
                custom: "Sur mesure",
            },
            status: {
                success: "Succès",
                pending: "En attente",
                error: "Erreur",
                refunded: "Remboursé",
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: "Supprimer",
                drop_here: "Déposez vos fichiers ici ou cliquez pour en sélectionner un",
                accepts: "Accepte les fichiers {{fileTypes}}",
                errors: {
                    max_files: "Maximum autorisé de {{number}}",
                    max_size: "Taille maximale du fichier de {{kilobytes}} Ko",
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: "Le restaurant est actuellement fermé on ne peut pas prendre de commande  pour manger au restaurant en ce moment. Veuillez essayer plus tard ou à une date ultérieure.",
            },
            buttons: {
                order: {
                    book_order: "Réserver une table/ Commander",
                    order_online: "Commander en ligne",
                    book_table: "Réserver une table",
                    order: "Commande",
                    book: "Réserver",
                    cart: "Panier",
                    restart: "Recommencer",
                    closed: "Commerce fermé",
                    not_accepting: "Nous n'acceptons pas les commandes",
                },
            },
        },
        modals: {
            auth: {
                login: "Connexion",
                register: "S’inscrire",
                register_commence: "Continuer",
                register_complete: "Créer un compte",
                register_confirmation_sent: "Un code de confirmation a été envoyé à votre adresse courriel. Veuillez l’entrer ci-dessous pour continuer",
                register_confirmation_resent: "Le code de confirmation a été envoyé à nouveau, vérifiez votre spam ou redémarrez le processus",
                register_restart: "Redémarrer",
                register_resend_code: "Renvoyer le code",
                login_placeholder: "Courriel",
                password_placeholder: "Mot de passe",
                confirm_password_placeholder: "Confirmez le mot de passe",
                confirmation_code_placeholder: "Code de confirmation par courriel",
                accept_terms: "J'accepte les modalités et conditions ",
                accept_terms_view: "Affichage",
                login_facebook: "Connexion avec Facebook",
                login_google: "Connexion avec Google",
                benefits: "Connectez-vous ou créez un compte pour enregistrer toutes vos commandes",
                logged_in: "Connexion réussie",
                logged_out: "Déconnexion",
                password_reset: {
                    init_button: "Envoyez un courriel de réinitialisation de mot de passe",
                    init_success: "Le lien de réinitialisation du mot de passe a été envoyé à votre courriel",
                    complete_button: "Réinitialisez   le mot de passe",
                    complete_success: "Réinitialisation du mot de passe réussie, ouverture de session avec votre nouveau mot de passe",
                    forgot_password_text: "Mot de passe oublié ?",
                    forgot_password_link: "Réinitialisez   le mot de passe",
                    remember_password_text: "Vous avez oublié votre mot de passe? ",
                    remember_password_link: "Retournez",
                    invalid_title: "Réinitialisation du mot de passe invalide",
                    invalid_description: "Ce lien de réinitialisation du mot de passe n’est pas valide, demandez plutôt un nouveau lien.",
                    invalid_link: "Allez sur Connexion",
                    title: "Réinitialisation du mot de passe",
                    description: "Saisissez un nouveau mot de passe pour votre compte",
                },
                error_generic: "Une erreur s'est produite ,veuillez réessayer ou nous contacter",
                error_accept_terms: "Veuillez accepter les modalités et conditions",
                error_password_length: "Minimum de 6 caractères pour le mot de passe",
                error_social: "Un problème est survenu,essayez à nouveau ou contactez-nous",
                error_confirmation_code: "Code de confirmation invalide",
                error_invalid_code: "Code de confirmation invalide",
                error_exists: "L'utilisateur existe déjà",
                error_invalid_email_pass: "Adresse courriel ou mot de passe incorrect",
                error_password_no_match: "Les mots de passe ne correspondent pas",
                error_user_not_found: "Il n'y a pas d'utilisateur à cette adresse courriel",
                error_invalid_email: "courriel non valide",
                error_invalid_reset_token: "Lien de réinitialisation invalide, demandez un autre lien",
            },
            booking: {
                form: {
                    name: "Nom complet",
                    email: "Adresse de courriel",
                    phone: "Numéro de téléphone",
                    number_of_people: "Nombre de personnes",
                    number_of_people_max: "Nombre de personnes ({{max_people}} Max)",
                    number_of_people_min: "Nombre de personnes ({{min_people}} Min)",
                    number_of_people_max_min: "Nombre de personnes (entre {{min_people}} et {{max_people}})",
                    notes: "Message / Demandes spéciales",
                    submit: "Soumettre une demande de réservation",
                    email_optional: "(facultatif)",
                    date: "Date",
                    duration: "Durée",
                    seating: "Horaires disponibles",
                    number_of_guests: "Nombre de convives",
                    notes_placeholder: "Allergies, occasion, préférence de placement",
                    reserving: "Réservation en cours...",
                    reserve_table: "Réserver une table",
                    please_choose_a_date_and_time: "Veuillez choisir une date et une heure.",
                    invalid_people: "Le nombre de convives doit être compris entre {{min}} et {{max}}.",
                    party_size_max_fallback: "le maximum autorisé",
                    loading_available_times: "Chargement des horaires disponibles…",
                    select_a_date_to_see_available_times: "Sélectionnez une date pour voir les horaires disponibles.",
                    no_times_available_for_this_date: "Aucun horaire disponible pour cette date. Veuillez choisir un autre jour.",
                    shift: "Service",
                    service_times: "Horaires de service",
                    new_shift: "Nouveau service",
                    time: "horaire",
                    times: "horaires",
                    unavailable: "Indisponible",
                    available: "Disponible",
                    required_name: "Veuillez saisir votre nom.",
                    required_phone: "Veuillez saisir votre numéro de téléphone.",
                    required_email: "Veuillez saisir votre adresse courriel.",
                    invalid_email: "Veuillez saisir une adresse courriel valide.",
                    required_terms: "Veuillez accepter les conditions avant de réserver.",
                    missing_custom_fields: "Veuillez répondre à toutes les questions obligatoires.",
                    reservation_is_unavailable: "La réservation n'est pas disponible.",
                    please_contact_the_restaurant_directly: "Veuillez contacter directement le restaurant.",
                    almost_done: "Presque terminé",
                    your_details: "Vos coordonnées",
                    tell_us_who_s_coming: "Dites-nous qui vient afin que nous puissions confirmer votre réservation.",
                    book_your_table: "Réservez votre table",
                    choose_a_time_that_works_for_you: "Choisissez un horaire qui vous convient.",
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: "Envoyez votre demande de réservation et le restaurant s'occupe du reste.",
                    select_date: "Sélectionner une date",
                    standard: "Standard",
                    minutes: "minutes",
                    next: "Suivant →",
                    back: "← Retour",
                    accept_terms: "J'accepte les modalités et conditions.",
                    info_1: "Vous recevrez une notification par courriel lorsque votre réservation sera acceptée ou refusée",
                },
                errors: {
                    not_found: "Il n'y a pas de réservation à ce nom,elle a peut-être été supprimée.",
                    generic: "Un problème est survenu, actualisez la page ou contactez-nous",
                    something_went_wrong: "Une problème est survenu",
                    accept_terms: "Veuillez accepter les modalités et conditions",
                    required_phone: "Veuillez entrer votre numéro de téléphone",
                    required_email: "Veuillez entrer votre courriel",
                    required_name: "Veuillez entrer votre nom",
                    invalid_email: "Veuillez saisir une adresse courriel valide",
                    invalid_phone: "Veuillez entrer un numéro de téléphone valide",
                    invalid_people: "Nombre de personnes invalides",
                    booking_capacity_threshold: "Nous sommes complets pour cet horaire. Veuillez essayer un autre créneau.",
                    slot_unavailable: "Nous sommes complets pour ce nombre de convives. Veuillez essayer un autre créneau.",
                    booking_date_paused: "Les réservations sont suspendues pour cette date. Veuillez choisir un autre jour.",
                    invalid_table_assignment: "Ces tables ne peuvent pas accueillir votre groupe. Veuillez choisir un autre horaire.",
                    exceeded_order_limit: "Trop de demandes de réservation. Veuillez réessayer plus tard.",
                    validation_failed_recaptcha_v3: "Trafic inhabituel détecté. Utilisez-vous un VPN ? Veuillez compléter le défi ci-dessus et réessayer.",
                    validation_failed_recaptcha_v2: "Impossible de lancer la réservation. Veuillez réessayer ou utiliser une autre méthode. Si vous utilisez un VPN, essayez de le désactiver d'abord.",
                    booking_already_exists: "Cette réservation a déjà été envoyée. Vérifiez vos courriels ou ouvrez votre lien de réservation.",
                    invalid_party_size: "Veuillez choisir un nombre de convives valide.",
                    invalid_request: "Requête non valide. Veuillez actualiser la page et réessayer.",
                    table_booking_unavailable: "La réservation de table n'est pas disponible.",
                },
            },
            cart: {
                title: "Panier",
                proceed_to_checkout: "Passer au paiement",
                edit_dish: "Modifier",
                remove_dish: "Supprimer",
                no_items_1: "Aucun produit dans le panier",
                no_items_2: "Ajoutez un article avant de continuer",
                free_delivery_notice: "Livraison gratuite pour les commandes supérieures à {{value, currency}}",
                errors: {
                    min_order_promo: "Valeur minimale du panier de {{value, currency}} requise avant l’application de cette promotion",
                    min_order_delivery: "Panier minimum de {{value, currency}} pour la livraison",
                },
                promo: {
                    heading: "Code promotionnel",
                    placeholder: "Entrez votre code de  promotion",
                    add: "Ajoutez un code",
                    title: "Promo {{name}} ajoutée au panier",
                    fixed_discount: "",
                    percent_discount: "",
                    added_to_cart: "Promo ajoutée au panier",
                    errors: {
                        not_found: "Promo introuvable",
                        disabled: "La promotion est désactivée",
                        not_available: "Promo n’est pas disponible actuellement",
                        logged_in_only: "Vous devez être connecté pour utiliser cette promotion",
                        already_used: "Vous avez déjà utilisé cette promo",
                        invalid: "Cette promotion n’est plus valide",
                        invalid_service: "Cette promotion n’est pas valide pour le service que vous avez choisi.",
                        later_only: "Valable pour les précommandes uniquement",
                        now_only: "Valable uniquement pour les commandes dues immédiatement et non pour les précommandes",
                        generic: "Oups... un proplème est survenu au moment de la connexion",
                        dishes_required_multi: "Cette promo ne sera appliquée que lorsque certains articles seront ajoutés à votre panier",
                        dishes_required_single: "Cette promotion ne sera appliquée que pour '{{dish}}'",
                    },
                },
                tip: {
                    title: "Pourboire",
                    placeholder: "Ajouter un pourboire",
                },
            },
            checkout: {
                title: "Paiement",
                subtitle: "Confirmez les détails de votre commande",
                details: {
                    service: "Service",
                    due: "Dû",
                    due_now_asap: "Maintenant /Dès que possible",
                    address: "Adresse de livraison",
                    total: "Total",
                    table: "Table",
                    store_location: "Adresse du commerce",
                },
                customer: {
                    title: "Client",
                    subtitle: "Connectez-vous pour enregistrer votre commande & détails",
                    button: "Crée mon compte",
                    name: "Nom complet",
                    email: "Adresse de courriel",
                    phone: "Numéro de téléphone",
                    phone_important: "Numéro de téléphone (important)",
                    notes: "Notes pour le comptoir",
                    delivery_notes: "Instructions de livraison / Notes pour le comptoir",
                    optional: "Facultatif"
                },
                payment: {
                    title: "Mode de paiement",
                },
                accept_terms: "J'accepte les les modalités et conditions ",
                accept_terms_view: "Affichage",
                processing_order: "Commande en cours...",
                warning: {
                    different_payment_currency: "Les prix du commerçant sont dans {{store_currency}} mais le mode de paiement est dans {{payment_currency}}",
                    closing_soon: "Le commerçant fermera bientôt, les commandes doivent être passées dans les {{value}} minutes",
                    closed: "Désolé, ce service est fermé  et on n'accepte plus les commandes",
                    expired: "On ne peut pas remplir votre commande à l'heure indiquée. Veuillez choisir une date ou une heure ultérieure",
                },
                errors: {
                    stripe_generic: "Erreur de carte de crédit, essayez à nouveau ou un autre mode de paiement",
                    validation_failed: 'Ce paiement ne peut pas être accepté pour le moment. Veuillez réessayer plus tard ou choisir un autre mode de paiement.',
                    stripe_loading_fail: "Erreur lors du chargement du formulaire de paiement, veuillez réessayer",
                    something_went_wrong: "Un problème est survenu",
                    paypal_generic: "Un problème est survenu avec PayPal, essayez à nouveau ou choisissez un autre mode de paiement",
                    payment_fail: "Le paiement a échoué, veuillez réessayer ou sélectionner un autre mode de paiement",
                    payment_cancelled: "Paiement annulé, veuillez réessayer ou sélectionner un autre mode de paiement",
                    payment_error: "Erreur de traitement du paiement en ligne, réessayer ou choisir un autre mode de paiement",
                    payment_declined: "Votre mode de paiement a été refusée.",
                    card_declined: "Votre carte a été refusée et le paiement n’a pu être traité.",
                    promo_max_uses_exceeded: "Ce code promo a atteint sa limite d’utilisation et n’est plus disponible.",
                    store_closed: "Le commerce est fermé et n’accepte plus les commandes",
                    accept_terms: "Veuillez accepter les modalités et conditions",
                    required_payment: "Veuillez sélectionner un mode de paiement",
                    required_phone: "Veuillez entrer votre numéro de téléphone",
                    required_email: "Veuillez entrer votre courriel",
                    required_name: "Veuillez entrer votre nom",
                    invalid_email: "Veuillez indiquer  une adresse courriel valide",
                    invalid_phone: "Veuillez entrer un numéro de téléphone valide",
                    invalid_cc_number: "Votre numéro de carte de crédit n’est pas valide",
                    retry_cc_number: "Un problème est survenu,entrez de nouveau votre numéro de carte de crédit et réessayez",
                    closed: "Le commerce est fermé/a fermé plus tôt et n'accepte plus les  commandes",
                    promo_login_required: "Vous devez être connecté pour utiliser cette promotion",
                    promo_used: "Vous avez déjà utilisé cette promo",
                    exceeded_order_limit: "Nous recevons beaucoup de commandes en ce moment. Veuillez choisir un horaire plus tard.",
                    exceeded_order_limit_later: "Nous ne pouvons plus exécuter votre commande à l'heure sélectionnée. Veuillez choisir une date ou une heure ultérieure.",
                },
                button: {
                    continue: "Continuez au paiement",
                    place_order: "Complétez la commande",
                },
            },
            customer: {
                age_v: {
                    title: "Vérification de l’âge",
                    required_for_items: "Requis pour commander certains articles",
                    min_age: "Âge minimum : {{age}} ans",
                    est_time: "Durée estimée de la vérification : {{time}} heures",
                    upload_description: "Téléchargez votre ID ci-dessous pour vérification. Vous serez averti par courriel une fois vérifié. Téléchargez jusqu’à 2 images d’une taille maximale de 2 Mo chacune",
                    pending_description_1: "Merci d’avoir soumis vos documents. Vous serez avisé par courriel lorsque votre demande sera approuvée.",
                    pending_description_2: "Actualisez la page pour mettre à jour votre état de vérification. Le temps de vérification estimé est de {{time}} heures",
                    approved_description: "Votre compte a été vérifié et vous pouvez commander à partir de menus restreints",
                    rejected_description: "Votre pièce d’identité a été rejetée. Si vous souhaitez réessayer, veuillez télécharger de nouveau votre pièce d’identité.",
                    upload: "Téléversement",
                    reupload: "Téléchargez à nouveau  les documents",
                    go_back: "Revenir en arrière",
                    view_document: "Voir le document {{number}}",
                    status: {
                        unverified: "Non vérifié",
                        pending: "En attente d’approbation",
                        approved: "Vérifié avec succès",
                        rejected: "Rejeté",
                    },
                },
                headings: {
                    sessions: "Sessions",
                    orders: "Commande",
                    spend: "Dépenser",
                    order_history: "Historique des commandes",
                    loyalty_points: "Points de fidélité",
                },
            },
            custom_payment: {
                title: "{{name}} Formulaire de paiement",
                description: "Vous êtes rendu sur notre formulaire  de paiement en ligne. Veuillez remplir les champs ci-dessous pour effectuer un paiement. Si un montant n’est pas entré, vos coordonnées seront enregistrées, mais vous ne serez pas facturé.",
                disabled: "Cette page de paiement en ligne n’a pas été configurée correctement. Veuillez contacter le propriétaire du site pour corriger le problème.",
                success: "Votre paiement a été traité avec succès et vos coordonnées ont été enregistrées. Merci",
                back: "Retour à la page d'accueil",
                fields: {
                    name: "Nom complet",
                    email: "Adresse de courriel",
                    reference: "Réf. de paiement",
                    amount: "Montant ($)",
                    name_on_card: "Nom sur la carte",
                    submit: "Soumettre le paiement",
                },
                warning: {
                    currency: "Remarque : Montant du paiement dans {{actual}}, et non {{default}}",
                },
                errors: {
                    generic: "Un problème est survenu , essayez à nouveau ou contactez-nous",
                    stripe_generic: "Erreur de carte de crédit, actualiser la page et réessayer",
                    payment_fail: "Le paiement a échoué, veuillez réessayer ou sélectionner un autre mode de paiement",
                    payment_cancelled: "Paiement annulé, veuillez réessayer ou sélectionner un autre mode de paiement",
                    payment_error: "Erreur de traitement du paiement en ligne, réessayer ou choisir un autre mode de paiement",
                    payment_declined: "Votre mode de paiement a été refusé",
                    card_declined: "Votre carte a été refusée et le paiement n’a pu être traité.",
                    promo_max_uses_exceeded: "Ce code promo a atteint sa limite d’utilisation et n’est plus disponible.",
                },
            },
            dish: {
                add: "Ajouter au panier",
                edit: "Mettre à jour",
                notes: "Instructions spéciales...",
                ingredients: {
                    title: "Ingrédients",
                    uncheck_remove: "Désélectionnez",
                },
                ingredients_title: "Ingrédients",
                combo: {
                    choose_dish: "Choisissez un article",
                },
                option_sets: {
                    conditions: {
                        select_one: "Sélectionnez un (obligatoire)",
                        select_one_optional: "Sélectionner un (facultatif)",
                        select_between: "Sélectionner {{min}} - {{max}} (obligatoire)",
                        select_at_least: "Sélectionnez au moins {{qty}} (obligatoire)",
                        select_up_to: "Sélectionnez jusqu’à {{qty}} (facultatif)",
                        select_multiple: "Sélectionnez multiple (facultatif)",
                        free_amount: "Premier {{qty}} gratuit / {{selected}} choisi",
                    },
                },
                error: "Veuillez corriger les options marquées en rouge.",
                added_to_cart: "Produit ajouté au panier",
            },
            map: {
                zone_fee: "Frais de livraison",
                view_in_google: "Afficher dans Google Maps",
            },
            portal_go_back: {
                title: "Retourner pour trouver un commerce?",
                description: "Tous les articles de votre panier seront perdus",
                cancel: "Annuler",
                proceed: "Retour",
            },
            order: {
                config: {
                    services: {
                        title: "Choisir un service",
                        table_booking: "Réserver une table",
                    },
                    address_custom: {
                        input_placeholder: "Entrez votre adresse",
                    },
                    address: {
                        input_placeholder: "Trouver votre adresse de livraison",
                        extras_placeholder: "Facultatif : numéro d’unité, nom du bâtiment, etc...",
                        search_placeholder: "Rechercher votre adresse",
                        not_found: "Adresse de livraison non trouvée ou non valide, réessayez",
                        not_delivering: "Nous ne livrons actuellement pas à cette adresse.",
                        not_in_range: "Votre adresse ne fait pas partie de notre territoire de livraison",
                        not_in_zone: "Votre adresse n’est pas dans une zone de livraison active",
                    },
                    datetime: {
                        title: "Quand aimeriez-vous votre commande",
                        due_now: "Maintenant",
                        due_later: "Plus tard",
                        service_not_available: "Désolé, nous n’acceptons pas les commandes de {{service}} {{service}} actuellement fermé, mais vous pouvez commander pour plus tard",
                        currently_closed: "",
                        due_unavailable: "Non disponible",
                        due_closed: "Fermé",
                        select_date: "Sélectionnez une date.",
                        select_time: "Sélectionnez une heure",
                        select_order_date: "Sélectionnez la date de votre commande",
                        select_order_time: "Sélectionnez l’heure de votre commande",
                        select_order_date_time: 'Sélectionnez la date/heure de votre commande',
                        select_booking_date: "Sélectionnez votre date de réservation",
                        select_booking_time: "Sélectionnez l’heure de votre réservation",
                        no_times_available: "Aucune heure disponible ",
                        date_today: "(Aujourd'hui)",
                        date_closed: "(Fermé)",
                        date_bookings_paused: "(Réservations suspendues)",
                        time_slot_closed: "Fermé",
                    },
                    number_of_people: {
                        placeholder: "Nombre de personnes",
                    },
                    table: {
                        select: "Sélectionnez une table",
                        select_popup_title: "Sélectionnez votre table",
                        password: "Mot de passe de la table",
                        password_warning: "Saisissez le mot de passe de la table pour continuer",
                    },
                    warning: {
                        closed: "Désolés,nous sommes actuellement fermés / nous n’acceptons aucune commande",
                        not_available: "Désolés,nous n’acceptons actuellement aucune commande",
                    },
                    eta: {
                        pickup: `La commande sera prête dans environ {{minutesToCustomer}} minutes`,
                    },
                    start_button: "Commander",
                },
                history: {
                    invalid: "Ne sont pas admissibles pour une nouvelle commande, car certains des articles commandés ont été modifiés ou ne sont plus disponibles.",
                },
                reorder: {
                    title: "Nouvelle commande rapide",
                    description: "Commandez facilement les articles de vos commandes précédentes",
                },
            },
            receipt: {
                errors: {
                    not_found: "Commande introuvable, actualisez la page et réessayez",
                    booking_not_found: "La réservation n'existe pas. Elle a peut-être été supprimée",
                    generic: "Un problème est survenu, actualisez la page ou contactez-nous",
                },
                connection: {
                    connected: "Mises à jour en temps réel",
                    connecting: "Connexion des mises à jour en temps réel",
                    disconnected: "Déconnexion des mises à jour en temps réel",
                },
            },
            warnings: {
                logout: {
                    pretitle: "Avertissement",
                    title: "Déconnexion",
                    body: "Se déconnecter supprimera tous les éléments qui ont été ajoutés à votre panier",
                    cancel: "Annuler",
                    proceed: "Continuer",
                },
                order_restart: {
                    warning: "Avertissement",
                    title: "Modifiez les détails de la commande",
                    body: "Modifier les détails de votre commande supprimera les articles dans votre panier car certains articles pourraient être épuisés",
                    cancel: "Annuler",
                    proceed: "Continuer",
                },
                order_expired: {
                    subtitle: "Important",
                    title: "Votre commande a été modifiée pour être due immédiatement ",
                    description: "L’heure sélectionnée  pour votre commande approche .Par conséquent, votre commande a été modifiée pour être due immédiatement /dès que possible",
                    button: "D'accord",
                },
                order_expiring: {
                    subtitle: "Important",
                    title: "La date limite de commande expire",
                    description: "Votre commande doit être passée avant {{time, timeFromTimestamp}} sinon elle n’est plus valide",
                    button: "D'accord",
                },
            },
        },
        sections: {
            nav_top: {
                guest: "Invité",
                login: "Connexion",
                login_signup: "Connexion / S'inscrire",
                logout: "Déconnexion",
            },
            menus: {
                info: {
                    no_menus: "Il n’y a actuellement aucun menu disponible",
                    restrictions: "Restrictions du menu",
                    not_available: "Menu actuellement indisponible",
                    unavailable: {
                        times: "Ce menu n'est pas dispoblible, les articles commandés ne font pas partie du menu ci-dessous",
                        services: "Menu indisponible, vos exigences de commande ne correspondent pas ci-dessous",
                        hours: "Le menu n’est pas disponible,votre heure de commande ne fait pas partie de nos heures d'ouverture",
                        pre_order: "Menu non disponible , votre commande ne correspond pas aux conditions de pré-commande",
                        age: "Menu non disponible, vous devez être connecté avec un compte vérifié par l’âge pour commander à partir de ce menu",
                    },
                    services: {
                        title: "Exigences relatives aux commandes",
                        pickup: "À emporter",
                        delivery: "Livraisons",
                        dine_in: "Sur place",
                    },
                    times: {
                        now: "Pas de précommandes",
                        later: "Précommandes seulement",
                    },
                    hours: {
                        title: "Heures disponibles",
                    },
                    preorder: {
                        title: "Exigences de précommandes",
                        days_in_advance: "Doit commander {{days}} jours à l’avance",
                        cutoff_time: "Heure limite du dernier jour à {{time, timeFromTime}}",
                    },
                    age_restricted: {
                        title: "Limite d’âge",
                        approved: "a été vérifié  et vous pouvez commander à partir de ce menu",
                        rejected: "Nécessite une vérification de l’âge pour commander. Créez un compte et téléchargez votre ID",
                    },
                },
            },
            info: {
                location: {
                    title: "Emplacement",
                    view_map: "Voir la carte",
                    phone: "Téléphone",
                },
                hours: {
                    title: "Heures d’ouverture",
                    title_special: "Heures d’ouverture spéciales",
                },
                services: {
                    title: "Services",
                    notes: "Notes",
                    delivery: {
                        ranges: "Gammes de livraison",
                        zones: "Zones de livraison",
                        view_zones: "Affichez les zones",
                        fee: "Frais de livraison",
                        fee_short: 'Frais',
                        fee_varies: "Varie, indiqué dans le panier",
                        min_order: "Commande minimum",
                        min_order_short: 'Com. min.',
                        no_min_order: "Pas de commande minimum",
                        free_amount: "Montant pour une livraison gratuite",
                    },
                },
            },
            contact: {
                title: "Contactez-nous",
                name: "Nom",
                email: "Courriel",
                phone: "Numéro de téléphone",
                message: "Entrez votre message...",
                send: "Envoyer",
                success: "Votre message a été envoyé avec succès",
                error: "Un problème est survenu ,essayez à nouveau ou plus tard",
            },
            footer: {
                powered_by: "Généré par",
                terms_and_conditions: "Modalités et conditions",
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Reçu de réservation',
            details: {
                datetime: 'Réservation pour',
                number_of_people: 'Nombre de personnes',
                placed: 'Placé',
                updated: 'Dernière mise à jour',
                notes: 'Notes',
                name: 'Nom',
                email: 'Courriel',
                phone: 'Téléphone',
                store_address: 'Adresse du commerce',
            },
            status_update: {
                title: 'Réservation {{number}} Mise à jour',
                body: 'Votre statut de réservation a été mis à jour à {{status}}',
            },
            email_delayed_order: {
                delayed_order_title: 'Notification de changement de commande',
                order_number: 'Numéro de commande: {{number}}',
                order_time_updated_to: 'Heure de la commande mise à jour à: {{time}}',
            },
            email_status_update_customer: {
                subject: 'Réservation #{{number}} – {{subjectLabel}}',
                body: 'Votre réservation #{{number}} chez {{store}} est maintenant {{status}}.',
            },
            errors: {},
        },
    },
    email_delayed_order: {
        subject: 'Commande #{{number}} – {{subjectLabel}}',
        header: 'Heure de préparation mise à jour',
        title: 'Heure de préparation mise à jour',
        order_number: 'Numéro de commande: {{number}}',
        description: 'Votre commande sera maintenant prête à {{time}}.',
        order_time_updated_to: 'L\'heure de votre commande a été mise à jour.',
        powered_by: 'Alimenté par {{name}}',
        button_text: 'Suivi de commande',
        subject_label: 'Heure de préparation mise à jour',
        subject_label_delivery: 'Heure de livraison mise à jour',
        body_ready: 'Votre commande sera maintenant prête à {{time}}.',
        body_delivery: 'Votre commande sera maintenant livrée à {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: 'Est. du temps de préparation',
            est_driver_pickup_time: 'Est. du temps de à emporter',
            est_delivery_time: 'Est. du délai de livraison',
            tab_details: 'Détails',
            tab_dishes: 'Produits',
            details: {
                status: 'État',
                placed: 'Placé',
                due: 'Dû',
                due_asap: 'Maintenant /dès que possible',
                last_updated: 'Dernière mise à jour',
                total: 'Total',
                type: 'Type',
                table: 'Table',
                number_of_people: 'Nombre de personnes',
                payment_method: 'Mode de paiement',
                payment_status: 'État du paiement',
                payment_currency: 'Devise de paiement',
                notes: 'Notes',
                name: 'Nom',
                email: 'Courriel',
                phone: 'Téléphone',
                distance: 'Distance',
                driving_time: 'Temps de livraison',
                delivery_zone: 'Zone',
                delivery_address: 'Adresse de livraison',
                delivery_tracking: 'Suivi de la livraison',
                delivery_tracking_link: 'Lien de suivi en temps réel',
                tookan_status: 'Statut de Tookan',
                tookan_status_failed_book: 'Échec de la réservation de la livraison',
                tookan_status_failed_update: 'Échec de la mise à jour de la réservation',
                tookan_status_success: 'Réservé pour la livraison',
                store_address: 'Adresse du commerce',
            },
            dishes: {
                headings: {
                    quantity: 'Qté',
                    item: 'Item',
                    price: 'Prix',
                },
                notes: 'Notes',
                remove_ingredients: 'Supprimer les ingrédients',
            },
            status_update: {
                title: 'Commande {{number}} Mise à jour',
                body: 'Le statut de votre commande a été mis à jour à {{status}}',
            },
            wait_time_update: {
                title: 'Commande {{number}} Mise à jour',
                body: 'Votre délai de commande a été mis à jour',
            },
            delivery_update: {
                title: 'Commande {{number}} Mise à jour',
                body: 'Votre commande a été réservée pour la livraison. Voir le lien de suivi en temps réel',
            },
            payment_status_update: {
                title: 'Order {{number}} Updated',
                body: 'Your order payment status has been updated.',
            },
            email_new_order_restaurant: {
                subject: "New Order ({{number}}) - {{name}}",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your admin dashboard",
                button_text: "Suivi de commande",
                track_delivery_button_text: "Suivre la livraison",
            },
            email_new_order_customer: {
                subject: "Order Receipt ({{number}})",
                powered_by: "Powered By {{name}}",
                overview: "New Order Notification",
                title: "New Order Placed At {{name}}",
                subtitle: "Order Number {{number}}",
                description: "View details and updates through your real-time online receipt",
                button_text: "Suivi de commande",
                track_delivery_button_text: "Suivre la livraison",
            },
        },
        totals: {
            tax: "{{name}} ({{percent}}%)",
            tax_in_prices: "{{name}} ({{percent}}%) inc. dans le prix",
            fee: "{{name}} ({{value, currency}} + {{percent}}%)",
            fee_percent: "{{name}} ({{percent}}%)",
            fee_fixed: "{{name}}",
            delivery_fee: "Frais de livraison",
            promo: "Rabais : {{name}} ({{value, currency}} + {{percent}}% de réduction)",
            promo_percent: "Rabais : {{name}} ({{percent}}%)",
            promo_fixed: "Rabais : {{name}}",
            promo_none: "Rabais : {{name}}",
            cart: "Panier",
            tip: "Pourboire",
            total: "Total",
        },
        status: {
            unconfirmed: "Non confirmé",
            confirmed: "Confirmé",
            ready: "Prêt",
            on_route: "En route",
            complete: "Terminé",
            cancelled: "Annulé",
            seated: "Installé",
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: "Non disponible",
                },
            },
            dish: {
                no_stock: "Épuisé",
                not_available: "Non disponible",
            },
        },
    },
};
//# sourceMappingURL=fr.js.map